import React from 'react'
import { LinkNavigation } from 'shared-global-ec-uikit/components/dist/react/esm'
import { FormattedMessage } from 'react-intl'

type Props = {
  donotSellLabel: string
  url: string
}

const DonotSellPersonalInfo = ({ donotSellLabel, url }: Props) => {
  return (
    <LinkNavigation variant="TitleSmall" element="a" href={url}>
      <FormattedMessage id={donotSellLabel} />
    </LinkNavigation>
  )
}

export default DonotSellPersonalInfo
